// extracted by mini-css-extract-plugin
export default {"ctaSection":"CTA_ctaSection__Ax5Ny","title":"CTA_title__6pSni","description":"CTA_description__EKamn","ctaButton":"CTA_ctaButton__ftJ4Y"};